<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="2")
              div {{ $t('ui.full_time') }}
            th(colspan="2")
              div {{ $t('ui.half_time') }}
          tr
            th(style="width: 100px;")
              div {{ $tc('ui.odds', 1) }}
            th(style="width: 100px;")
              div {{ $t('ui.even') }}
            th(style="width: 100px;")
              div {{ $tc('ui.odds', 1) }}
            th(style="width: 100px;")
              div {{ $t('ui.even') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.fodd_blink }") {{ item.fodd }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.feven_blink }") {{ item.feven }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.hodd_blink }") {{ item.hodd }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.heven_blink }") {{ item.heven }}
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>